import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
  moreProductsLoaded,
  previousProductsLoaded,
  receiveProducts,
} from "./actionCreators";
import {
  analyticsLoadMore,
  analyticsLoadPrevious,
  applyAndRemovePendingEvents,
} from "../../../analytics/actions";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: moreProductsLoaded,
  effect: (action, { dispatch }) => {
    if (action.error) {
      return;
    }

    dispatch(
      analyticsLoadMore({
        response: action.payload,
        page: action.payload.page,
      }),
    );
  },
});

listenerMiddleware.startListening({
  actionCreator: previousProductsLoaded,
  effect: (action, { dispatch }) => {
    if (action.error) {
      return;
    }

    dispatch(
      analyticsLoadPrevious({
        response: action.payload,
        page: action.payload.page,
      }),
    );
  },
});

listenerMiddleware.startListening({
  actionCreator: receiveProducts,
  effect: (action, { dispatch }) => {
    if (action.error) {
      return;
    }

    dispatch(applyAndRemovePendingEvents());
  },
});

export const searchListenersMiddleware = listenerMiddleware.middleware;
